export interface DraftOnlyBlockInput {
  currentVersion?: number | null;
  currentVersionId?: string | number | null;
}

/**
 * True for a block that has never been published. `POST /blocks` creates a block as a Draft with
 * `currentVersion: 0`, `currentVersionId: null` and a single open Draft v1 (returned as
 * `draftVersionId`); the block only gains a published version through PUT draft + publish.
 *
 * Such a block must never present Draft v1 as published, and cannot be duplicated (404) or imported
 * into a template (409) until it is published.
 */
export function isDraftOnlyBlock(block: DraftOnlyBlockInput): boolean {
  const hasPublishedPointer = block.currentVersionId != null && String(block.currentVersionId).trim() !== '';
  return (block.currentVersion ?? 0) === 0 && !hasPublishedPointer;
}
